import styled, { css } from 'styled-components'
import SubmitButton from '../../../../Components/Form/SubmitButton'

export const StyledWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 60%;
  padding: 41px;
`

export const StyledTitle = styled.span`
  font-size: 26px;
  font-weight: 400;
  color: #ee4360;
`

export const StyledInfo = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
`

export const StyledTextArea = styled.textarea`
  display: block;
  width: 100%;
  resize: none;
  padding: 16px 20px;
  background: ${props => props.theme.colors.alabaster};
  border: none;
  border-radius: 3px;
  outline: none;
  height: 200px;

  &::placeholder {
    font-size: ${props => props.theme.fontSizes.form.placeholder};
    color: ${props => props.theme.colors.placeholder};
    letter-spacing: 0.6px;
  }
  &:focus::placeholder {
    color: transparent;
  }
`

export const StyledWordsCount = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${props => (props.isReached ? 'red' : '#00112B')};
  text-align: right;
`

export const StyledButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 32px;
  width: 100%;
`

const CommonStyles = css`
  width: 154px;
  border-radius: 4px !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  text-transform: none !important;
`

export const StyledPreviewAdditionalInfoButton = styled(SubmitButton)`
  ${CommonStyles}
  background-color: #ffffff !important;
  color: #00112b !important;
  border: 1px solid #000000 !important;
`

export const StyledSaveAdditionalInfoButton = styled(SubmitButton)`
  ${CommonStyles}
`
